import { connect } from 'react-redux';
import actions from '../../actions';
import MfaScreen from '../components/MfaScreen/MfaScreen';

const MFA_STORAGE_KEY = 'nawaiam_mfa_pending';

const getStoredMfa = () => {
  try {
    const value = sessionStorage.getItem(MFA_STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch (_e) {
    return null;
  }
};

const mapStateToProps = (state) => ({
  mfa: state.session.mfa || getStoredMfa(),
  status: state.session.mfaStatus,
  resendStatus: state.session.mfaResendStatus,
});

const mapDispatchToProps = (dispatch) => ({ dispatch });

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  onVerify: (code) =>
    dispatchProps.dispatch(actions.session.mfaVerify(stateProps.mfa?.challenge_id, code)),
  onResend: () =>
    dispatchProps.dispatch(actions.session.mfaResend(stateProps.mfa?.challenge_id)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MfaScreen);
